'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getNodeDescription = getNodeDescription;
exports.getForeignNodeDescription = getForeignNodeDescription;

var _reduxSaga = require('redux-saga');

var _kebakaran = require('kebakaran');

var _firebase = require('../utils/firebase');

var _firebase2 = _interopRequireDefault(_firebase);

var _nodesActions = require('../actions/nodesActions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = [getCaption, getNodeDescription, getForeignNodeDescription].map(regeneratorRuntime.mark);
/* injects from baggage-loader */

/* eslint no-console: 0 */

function getCaption(captionRef) {
  var _sagaCb, listener, callback, caption;

  return regeneratorRuntime.wrap(function getCaption$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _sagaCb = (0, _kebakaran.sagaCbLoose)();
          listener = _sagaCb.listener;
          callback = _sagaCb.callback;

          captionRef.once('value', listener);
          _context.next = 7;
          return (0, _reduxSaga.cps)(callback);

        case 7:
          caption = _context.sent;
          return _context.abrupt('return', caption.val());

        case 11:
          _context.prev = 11;
          _context.t0 = _context['catch'](0);

          if (_context.t0 instanceof _reduxSaga.SagaCancellationException) {
            _context.next = 15;
            break;
          }

          throw _context.t0;

        case 15:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked[0], this, [[0, 11]]);
}

/*
function* setNodeOwner(nodeRef, ownerId) {
  try {
    nodeRef.child('owner').set(ownerId);
  } catch (err) {
    if (!(err instanceof SagaCancellationException)) {
      throw err;
    }
  }
}
*/

function getNodeDescription(projectId, nodeId) {
  var projectRefLink, captionRefLink, descriptionRefLink, projectOwnerRefLink, captionStream, projectOwnerStream, _caption, owner;

  return regeneratorRuntime.wrap(function getNodeDescription$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          //if (!nodeId) {
          //  yield put(setEditorNode(null));
          //  return;
          //}
          projectRefLink = 'projects/' + projectId;
          captionRefLink = projectRefLink + '/nodesData/' + nodeId + '/caption';
          descriptionRefLink = projectRefLink + '/descriptions/' + nodeId;
          projectOwnerRefLink = projectRefLink + '/owner';
          captionStream = (0, _kebakaran.stream)((0, _firebase2.default)(captionRefLink));
          projectOwnerStream = (0, _kebakaran.stream)((0, _firebase2.default)(projectOwnerRefLink));
          _context2.prev = 6;
          _context2.next = 9;
          return captionStream.next();

        case 9:
          _caption = _context2.sent;
          _context2.next = 12;
          return projectOwnerStream.next();

        case 12:
          owner = _context2.sent;
          _context2.next = 15;
          return (0, _reduxSaga.put)((0, _nodesActions.setEditorNode)({
            id: nodeId,
            refLink: descriptionRefLink,
            owner: owner,
            caption: _caption
          }));

        case 15:
          _context2.next = 21;
          break;

        case 17:
          _context2.prev = 17;
          _context2.t0 = _context2['catch'](6);

          if (_context2.t0 instanceof _reduxSaga.SagaCancellationException) {
            _context2.next = 21;
            break;
          }

          throw _context2.t0;

        case 21:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked[1], this, [[6, 17]]);
}

function getForeignNodeDescription(projectId, nodeId) {
  var caption, descriptionRefLink, descriptionHistoryRef, _sagaCb2, listener, callback;

  return regeneratorRuntime.wrap(function getForeignNodeDescription$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          if (nodeId) {
            _context3.next = 4;
            break;
          }

          _context3.next = 3;
          return (0, _reduxSaga.put)((0, _nodesActions.setEditorNode)(null));

        case 3:
          return _context3.abrupt('return');

        case 4:
          _context3.next = 6;
          return (0, _reduxSaga.call)(getCaption, (0, _firebase2.default)('projects/' + projectId + '/nodesData/' + nodeId + '/caption'));

        case 6:
          caption = _context3.sent;
          descriptionRefLink = 'projects/' + projectId + '/descriptions/' + nodeId;
          descriptionHistoryRef = (0, _firebase2.default)(descriptionRefLink + '/history');
          _sagaCb2 = (0, _kebakaran.sagaCbLoose)();
          listener = _sagaCb2.listener;
          callback = _sagaCb2.callback;

          descriptionHistoryRef.on('value', listener);

          _context3.prev = 13;

        case 14:
          if (!true) {
            _context3.next = 21;
            break;
          }

          _context3.next = 17;
          return (0, _reduxSaga.cps)(callback);

        case 17:
          _context3.next = 19;
          return (0, _reduxSaga.put)((0, _nodesActions.setEditorNode)({
            id: nodeId,
            refLink: descriptionRefLink,
            timestamp: new Date().getTime(),
            caption: caption
          }));

        case 19:
          _context3.next = 14;
          break;

        case 21:
          _context3.next = 26;
          break;

        case 23:
          _context3.prev = 23;
          _context3.t0 = _context3['catch'](13);

          if (!(_context3.t0 instanceof _reduxSaga.SagaCancellationException)) {
            console.warn('unknown Error', _context3.t0);
          }

        case 26:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked[2], this, [[13, 23]]);
}


//////////////////
// WEBPACK FOOTER
// ./app/sagas/nodeDescription.js
// module id = 635
// module chunks = 1